module.exports = __webpack_public_path__ + "img/UGA-LucyCobbHouse-474x349.5d26ede3.jpg";